export default __webpack_public_path__ + "static/media/SteveMyrland.2e23a7e1.png";